"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Monitoring = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _InfoBar = require("../InfoBar");

var _ToolBar = require("../ToolBar");

var _Page = require("../../Layout/Page");

var _ExpandableGroup = require("../ExpandableGroup");

var _utils = require("../utils");

var _hooks = require("../utils/hooks");

var _options = require("../utils/options");

var _storage = require("../../../utils/storage");

var _analysis = require("../../../context/analysis");

var _constants = require("../utils/constants");

var _LoadingOverlay = require("../../ActionModals/components/LoadingOverlay");

const onSearch = (setFiltered, setQuery) => ({
  filtered,
  query
}) => {
  setFiltered(filtered);
  setQuery(query);
  (0, _storage.setPersisted)({
    key: 'Monitoring-search',
    prop: 'query'
  }, query);
};

const onTimeRangeChange = (updateTimeRange, history) => days => {
  (0, _utils.updateQueryString)(`${days}`, history, 'daysRange');
  updateTimeRange(days);
};

const onExpand = (expandAll, setExpandAll) => () => {
  (0, _storage.clearStorage)({
    key: _constants.EXPANDING_KEY.monitoring
  });
  setExpandAll(!expandAll);
};

const onGroupChange = setGroup => option => {
  setGroup(option);
  (0, _storage.setPersisted)({
    key: 'Monitoring-groups',
    prop: 'groupBy'
  }, option);
};

const onSortChange = setSort => option => {
  setSort(option);
  (0, _storage.setPersisted)({
    key: 'Monitoring-groups',
    prop: 'sortBy'
  }, option);
};

const Monitoring = ({
  category,
  data,
  history,
  timeRange,
  showSnoozed,
  updateHistory,
  updateTimeRange,
  isLoading
}) => {
  // Set the view mode to monitoring
  const {
    setViewMode
  } = (0, _analysis.useActions)();
  const firstRender = React.useRef(true); // Group open/close all state

  const {
    expandAll,
    setExpandAll
  } = (0, _hooks.useExpandedState)(firstRender.current, 'monitoring');
  const initialSearch = (0, _storage.getPersisted)({
    key: _constants.MONITORING_LS_KEY,
    prop: 'query'
  }, '');
  React.useEffect(() => {
    setViewMode('monitoring');
  }, []); // Data processing and group composition

  const {
    finalGrouped,
    counts,
    filtered,
    setFiltered,
    setGroup,
    setSort,
    composed,
    sort
  } = (0, _hooks.useMonitoringState)(data, category, showSnoozed, initialSearch !== '');
  const {
    setQuery
  } = (0, _hooks.useQueryState)(history, updateHistory); // Map timerange label from props

  const timeRangeLabel = React.useMemo(() => {
    return _options.TIME_RANGE_OPTIONS.monitoring.find(o => o.value === timeRange).label(_core.i18n);
  }, [timeRange]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Page.PageHeader, null, /*#__PURE__*/React.createElement(_blocks.DisplayMedium, null, /*#__PURE__*/React.createElement(_InfoBar.InfoBar, {
    insightsCount: counts.insightsCount,
    siteCount: counts.siteCount,
    equipCount: counts.equipCount,
    timeRange: timeRangeLabel
  }))), /*#__PURE__*/React.createElement(_ToolBar.ToolBar, {
    searchData: composed,
    snoozedCount: counts.snoozedCount,
    currentGroup: finalGrouped.group,
    currentSort: sort,
    timeRange: timeRange,
    expandAll: expandAll,
    onExpand: onExpand(expandAll, setExpandAll),
    onSearch: onSearch(setFiltered, setQuery),
    searchSessionKey: "monitoringSearch",
    initialSearch: initialSearch,
    onTimeRangeChange: onTimeRangeChange(updateTimeRange, history),
    onGroupChange: onGroupChange(setGroup),
    onSortChange: onSortChange(setSort)
  }), /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingContainer, null, isLoading && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, {
    opacity: 0.6
  }), /*#__PURE__*/React.createElement(_ExpandableGroup.ExpandableGroup, {
    finalGrouped: finalGrouped,
    showSnoozed: showSnoozed,
    expandAll: expandAll,
    filtered: filtered
  })));
};

exports.Monitoring = Monitoring;